const SectionDownload = Class(
	/**
	 * @lends {SectionDownload#}
	 */
	{
		bodyClass: 'small-nav full-container',
		menuItem: 'download',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'download'
			});
		},

		route() {
			this.type = this.url.shift() || 'default';
		},

		draw() {
			mkE({
				tag: 'div',
				id: 'download-info',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'h1',
								text: D.Lang.get('home.download-app')
							},
							new T.Download('', this.type),
							{
								tag: 'div',
								className: 'qr',
								els: [
									{
										tag: 'img',
										src: '/assets/images/qr.svg',
										attr: {
											alt: 'QR'
										}
									}
								]
							}
						]
					}
				]
			}).append(this.node);
			this._drawSocials();
			this.node.append(this.layout.ct());
			this.ready();
		},

		_drawSocials() {
			mkE({
				tag: 'div',
				className: 'container home-socials',
				els: [
					T.SocialIcons()
				]
			}).append(this.node);
		}
	},
	Section
);